import { Router, RouterModule } from '@angular/router';
import { Component, inject } from '@angular/core';
import { ButtonSize, ButtonState, ButtonType, IJobOffer } from '../../../../../assets/types/dtoTypes';
import { SharedModule } from '../../../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { JobComponent } from './job/job.component';
import { BIPPERZ_BREAKPOINTS, BreakpointsService } from '../../../../shared/services/breakpoint.service';
import {CompanyDashboardPageService} from "../company-dashboard-page/company-dashboard-page.service";

@Component( {
    selector: 'app-jobs-page',
    imports: [
        RouterModule,
        SharedModule,
        TranslateModule,
        JobComponent,
    ],
    templateUrl: './jobs-page.component.html',
    standalone: true,
    styleUrl: './jobs-page.component.scss'
} )
export class JobsPageComponent {
  private router = inject(Router);
  private breakpointsService = inject(BreakpointsService);


  protected readonly ButtonSize = ButtonSize;

  isMobile = false;

  isLoading = false;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  jobs: IJobOffer[] = [];

  constructor( private dashboardService: CompanyDashboardPageService) {
    const nav = this.router.getCurrentNavigation();
    const stateJobs = nav?.extras?.state?.jobs ?? [];

    if (stateJobs.length > 0) {
      this.jobs = stateJobs;
      this.isLoading = false;
    } else {
      this.isLoading = true;
      this.dashboardService.getJobOffers().subscribe({
        next: (jobOffers) => {
          this.jobs = jobOffers;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
    }



    this.breakpointsService.observe( [ BIPPERZ_BREAKPOINTS.s, BIPPERZ_BREAKPOINTS.m_down ] ).subscribe( ( result ) => {
      this.isMobile = result.s || result.m_down;
    } );
  }


}
